function o(l) {
  return {
    scrollLeft: l.scrollLeft,
    scrollTop: l.scrollTop
  };
}
export {
  o as default
};
//# sourceMappingURL=getHTMLElementScroll.mjs.map
